import React from 'react';
import PropTypes from 'prop-types';
import last from 'lodash/last';
import take from 'lodash/take';
import flatten from 'lodash/flatten';
import FilterList from 'components/FilterList';
import Icon from 'components/Icon';
import {ChartEndOfDrillTable} from 'handlers/Cards/CardHandler/components/ChartTable';
import DrillVisualization from 'handlers/Cards/CardHandler/components/DrillVisualization';
import styles from './CardDrillPaging.css?module';
import EmbedCardToolbar from './EmbedCardToolbar';

const toggleTable = ({isTableActive}) => ({isTableActive: !isTableActive});

class CardDrillPaging extends React.Component {
  state = {
    isTableActive: false,
  };

  handleTableActionClick = () => {
    this.setState(toggleTable);
  };

  render() {
    const {
      className,
      filters,
      drillFilters,
      filterGroupIds,
      dataControlFilters,
      pageId,
      card,
      onDrill,
      popDrill,
      index,
      dateRangeFilter,
    } = this.props;

    const {isTableActive} = this.state;

    const isEndOfDrill = card.drillPathURNs.length === index;

    const urn = isEndOfDrill
      ? last(card.drillPathURNs) || card.urn
      : card.drillPathURNs[index];

    const flatDrillFilters = flatten(take(drillFilters, index + 1))
      .reverse()
      .map((filter, filterIndex) => ({
        ...filter,
        applied: true,
        id: `drill-${filterIndex}`,
      }));
    const combinedFilters = [...flatDrillFilters, ...filters];

    return (
      <div className={styles.container + (className ? ' ' + className : '')}>
        <div className={styles.filters}>
          <div
            className={styles.back}
            role="button"
            aria-label="Back"
            onClick={popDrill}
          >
            <Icon icon={Icon.OPTIONS.ARROW_LEFT} />
          </div>
          <FilterList filters={combinedFilters} onFilterSelect={() => {}} />
          <div className={styles.toolbarContainer}>
            <EmbedCardToolbar
              isTableActive={isTableActive}
              filters={combinedFilters}
              onTableActionClick={this.handleTableActionClick}
              cardId={urn}
            />
          </div>
        </div>
        {!isEndOfDrill ? (
          <DrillVisualization
            cardId={urn}
            pageId={pageId}
            filters={combinedFilters}
            dateRangeFilter={dateRangeFilter}
            dataControlFilters={dataControlFilters}
            filterGroupIds={filterGroupIds}
            onDrill={onDrill}
            isTable={isTableActive}
          />
        ) : card.allowTableDrill ? (
          <ChartEndOfDrillTable
            cardId={card.urn}
            filters={combinedFilters}
            dateRangeFilter={dateRangeFilter}
            dataControlFilters={dataControlFilters}
            filterGroupIds={filterGroupIds}
          />
        ) : null}
      </div>
    );
  }
}

CardDrillPaging.propTypes = {
  dateRangeFilter: PropTypes.object,
  filters: PropTypes.array.isRequired,
  drillFilters: PropTypes.array.isRequired,
  filterGroupIds: PropTypes.array.isRequired,
  viewId: PropTypes.string,
  pageId: PropTypes.string,
  card: PropTypes.object.isRequired,
  onDrill: PropTypes.func.isRequired,
  popDrill: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default CardDrillPaging;
